import { useFormik } from 'formik';
import { useCallback } from 'react';
import * as Yup from 'yup';
import { useAuth } from 'hooks';
import { SystemLogoColorfulIcon } from 'static/icons';
import { Button, Input } from 'components';
import { formValidations } from 'helpers';
import { TEST_IDS } from 'commons';
import * as S from './styles';

export function LoginPage() {
  const { signIn } = useAuth();

  const { state } = window.history;
  const { pathname = '/', search = '', hash = '' } = state?.usr?.from ?? {};
  const pathBeforeLogin = `${pathname}${search}${hash}`;

  const initialValues = {
    email: '',
    password: '',
  };

  const LoginValidation = Yup.object().shape({
    email: Yup.string().required('E-mail'),
    password: Yup.string().required('Senha'),
  });

  const handleSubmit = useCallback(
    (values: { email: string; password: string }) => {
      signIn(values, pathBeforeLogin);
    },
    [pathBeforeLogin, signIn]
  );

  const form = useFormik({
    initialValues: initialValues,

    validationSchema: LoginValidation,

    validateOnBlur: false,

    validateOnChange: false,

    validate: (values) =>
      formValidations.validationSchema({ schema: LoginValidation, values }),

    onSubmit: (values) => handleSubmit(values),
  });

  return (
    <S.Container>
      <S.Background />

      <S.Content>
        <SystemLogoColorfulIcon />

        <form onSubmit={form.handleSubmit}>
          <Input
            data-testid={TEST_IDS.LOGIN_EMAIL_INPUT}
            name="email"
            label="E-mail"
            type="email"
            placeholder="usuário@domínio.com"
            onChange={form.handleChange}
            value={form.values.email}
            status={form.errors.email ? 'error' : 'default'}
          />

          <Input
            data-testid={TEST_IDS.LOGIN_PASSWORD_INPUT}
            type="password"
            name="password"
            label="Senha"
            placeholder="mínimo de 6 caracteres"
            onChange={form.handleChange}
            value={form.values.password}
            status={form.errors.password ? 'error' : 'default'}
          />

          <Button
            data-testid={TEST_IDS.LOGIN_CONFIRM_BUTTON}
            type="submit"
            full
          >
            Entrar
          </Button>

          <p className="google-terms">
            Este site é protegido pelo reCAPTCHA e aplicada a{' '}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noreferrer"
            >
              Política de Privacidade
            </a>{' '}
            e{' '}
            <a
              href="https://policies.google.com/terms"
              target="_blank"
              rel="noreferrer"
            >
              Termos de Serviço
            </a>{' '}
            do Google.
          </p>
        </form>

        <div className="support">
          <p>Problemas com seu acesso?</p>

          <p>
            Fale com nosso suporte via{' '}
            <a
              href="https://wa.me/+555121295354"
              target="_blank"
              rel="noreferrer"
            >
              chat
            </a>
          </p>
        </div>
      </S.Content>
    </S.Container>
  );
}
